<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Sync </span> /
      <span> Confirm </span>
    </nav>
    <sync-steps :method="method"></sync-steps>

    <div class="container">
      <h2 class="flow-heading mt-5 mb-3">A few final details before you complete your sync</h2>

      <flow-confirm-details header="CRM Sync" :details="details" :timezone="timezone">
        <div class="sync-confirm-page__notification">
          <i class="fas fa-info-circle fa-2x"></i>
          Contacts will be updated in both {{ platformTitle }} and the CRM. If a contact was changed in both platforms,
          the changes made in {{ platformTitle }} will be preserved.
        </div>
      </flow-confirm-details>

      <flow-conditions
        :platformTitle="platformTitle"
        heading="Before syncing, please read and attest to the following:"
        @read="readingFinished = true"
      ></flow-conditions>

      <form action="/sync/progress" method="POST" class="text-center">
        <input type="hidden" name="selectedGroupsIds" :value="selectedGroupsIds" />
        <input type="hidden" name="method" :value="method" />
        <div>
          <a class="btn btn-lg btn-outline-primary mr-2" href="/sync/select-groups/">Back</a>
          <button type="submit" class="btn btn-lg btn-primary" :disabled="!readingFinished">Finalize Sync</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SyncSteps from '../components/sync/SyncSteps';
import FlowConfirmDetails from '../components/shared/FlowConfirmDetails';
import FlowConditions from '../components/shared/FlowConditions';
import dateFormatter from '../mixins/dateFormatter';
import {getCommercialName} from '../utility/crms/getCommercialName.js';

export default {
  name: 'sync-confirm-page',
  mixins: [dateFormatter],
  components: {SyncSteps, FlowConfirmDetails, FlowConditions},
  data() {
    return {
      readingFinished: false,
    };
  },
  props: {
    selectedGroupsIds: {
      type: String,
      required: true,
    },
    selectedGroups: {
      type: String,
      required: true,
    },
    crm: {
      type: String,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      required: true,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    groups() {
      return JSON.parse(this.selectedGroups);
    },
    details() {
      return this.method === 'groups'
        ? [
            {name: 'Synced From', content: `${this.crmName} CRM`},
            {name: 'Groups to Sync', groups: this.groups},
          ]
        : [
            {name: 'Synced From', content: `${this.crmName} CRM`},
            {name: 'Upgrade existing contacts', content: 'Yes'},
          ];
    },
    crmName() {
      return getCommercialName(JSON.parse(this.crm).crm_name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.sync-confirm-page {
  &__notification {
    display: flex;
    align-items: center;
    gap: 16px;
    background: rgba(255, 204, 51, 0.5);
    border-radius: 100px;
    max-width: 638px;
    color: $mine-shaft-color;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    padding: 8px 24px;
    margin: 15px 0 20px;
  }
}
</style>
